// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgThings24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M2.3501 3.99961C2.3501 3.08834 3.08883 2.34961 4.0001 2.34961H9.0001C9.91139 2.34961 10.6501 3.08835 10.6501 3.99961V8.99961C10.6501 9.91089 9.91138 10.6496 9.0001 10.6496H4.0001C3.08883 10.6496 2.3501 9.9109 2.3501 8.99961V3.99961ZM4.0001 3.64961C3.8068 3.64961 3.6501 3.80631 3.6501 3.99961V8.99961C3.6501 9.19292 3.80679 9.34961 4.0001 9.34961H9.0001C9.19341 9.34961 9.3501 9.19292 9.3501 8.99961V3.99961C9.3501 3.8063 9.19341 3.64961 9.0001 3.64961H4.0001Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M2.3501 14.9996C2.3501 14.0883 3.08883 13.3496 4.0001 13.3496H9.0001C9.91138 13.3496 10.6501 14.0883 10.6501 14.9996V19.9996C10.6501 20.9109 9.91138 21.6496 9.0001 21.6496H4.0001C3.08883 21.6496 2.3501 20.9109 2.3501 19.9996V14.9996ZM4.0001 14.6496C3.80679 14.6496 3.6501 14.8063 3.6501 14.9996V19.9996C3.6501 20.1929 3.80679 20.3496 4.0001 20.3496H9.0001C9.19341 20.3496 9.3501 20.1929 9.3501 19.9996V14.9996C9.3501 14.8063 9.19341 14.6496 9.0001 14.6496H4.0001Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.3501 6.49961C13.3501 4.20763 15.2081 2.34961 17.5001 2.34961C19.7921 2.34961 21.6501 4.20763 21.6501 6.49961C21.6501 8.79159 19.7921 10.6496 17.5001 10.6496C15.2081 10.6496 13.3501 8.79159 13.3501 6.49961ZM17.5001 3.64961C15.9261 3.64961 14.6501 4.9256 14.6501 6.49961C14.6501 8.07362 15.9261 9.34961 17.5001 9.34961C19.0741 9.34961 20.3501 8.07362 20.3501 6.49961C20.3501 4.9256 19.0741 3.64961 17.5001 3.64961Z"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.3501 14.9996C13.3501 14.0883 14.0888 13.3496 15.0001 13.3496H20.0001C20.9114 13.3496 21.6501 14.0883 21.6501 14.9996V19.9996C21.6501 20.9109 20.9114 21.6496 20.0001 21.6496H15.0001C14.0888 21.6496 13.3501 20.9109 13.3501 19.9996V14.9996ZM15.0001 14.6496C14.8068 14.6496 14.6501 14.8063 14.6501 14.9996V19.9996C14.6501 20.1929 14.8068 20.3496 15.0001 20.3496H20.0001C20.1934 20.3496 20.3501 20.1929 20.3501 19.9996V14.9996C20.3501 14.8063 20.1934 14.6496 20.0001 14.6496H15.0001Z"
				/>
			</Svg>
		);
	}
);
SvgThings24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgThings24;
